// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c499f2b","453":"75a9b2f2","667":"e8a54e13","977":"0ca01914"}[chunkId] + ".chunk.js";
};